import { MESSENGER_INLINE_IMAGE_UPLOAD_BASENAME } from '../attachments/messengerInlineImageUploadFileName';

/**
 * Сжатие растрового изображения в JPEG (контейнер JFIF) на клиенте перед загрузкой.
 * Имя файла не наследуется от оригинала — только нейтральное (превью в чате).
 */
export async function compressImageToJfif(
  file: File,
  opts?: { quality?: number; maxEdge?: number }
): Promise<File> {
  const quality = opts?.quality ?? 0.82;
  const maxEdge = opts?.maxEdge ?? 2560;

  const bitmap = await createImageBitmap(file);
  try {
    let { width, height } = bitmap;
    if (width > maxEdge || height > maxEdge) {
      const scale = Math.min(maxEdge / width, maxEdge / height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas unsupported');
    ctx.drawImage(bitmap, 0, 0, width, height);

    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, 'image/jpeg', quality);
    });
    if (!blob) throw new Error('JPEG encode failed');

    return new File([blob], `${MESSENGER_INLINE_IMAGE_UPLOAD_BASENAME}.jpg`, {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });
  } finally {
    bitmap.close();
  }
}
